// A drawn signature as the API takes it: the image data without its data-URI prefix, or null when
// the pad has been cleared.
export function toSignatureValue(value) {
    if (value == null || value === "") {
        return null;
    }

    return value.split(",").pop();
}
